<script lang="ts">
  // components
  import ProductList from "@retailer/svelte/Shared/QuickOrderList/ProductList.svelte";
  import OpenProductGroupSummary from "@retailer/svelte/Shared/QuickOrderList/OpenProductGroupSummary.svelte";

  // types
  import type {
    QuickOrderListDetail,
    QuickOrderListFilters,
    ListType,
  } from "@shared/types/QuickOrderList";
  import type { QuickOrderListProduct } from "@shared/types/ProductLine";
  import type { OpenProductGroup } from "@shared/types/OpenProductGroup";
  import type { PageData } from "@shared/types/PageData";

  import { EventTracking } from "@shared/services/event_tracking/events";

  export let list: QuickOrderListDetail;
  export let filters: QuickOrderListFilters;
  export let page: PageData;
  export let products: QuickOrderListProduct[];
  export let openProductGroups: OpenProductGroup[] = [];
  export let listType: ListType;
  export let showLoading: boolean = false;
  export let showInventory: boolean;
  export let editMode: boolean;
  export let readOnly: boolean;
  export let useListLayout: boolean;
  export let sortObj;
  export let callbacks;

  const { trackClick } = EventTracking;
  let activeDynamicFiltersTab = "approved_products";

  const clickOpenProductGroupTab = () => {
    activeDynamicFiltersTab = "product_groups";
    trackClick("open_product_groups_tab");
  };
</script>

<style lang="scss">
  .fizz-tab-list.mobile-horizontal-scroll {
    @media (max-width: 767px) {
      overflow-x: scroll;
      // hide unless scrolling on firefox
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    @media (min-width: 768px) and (max-width: 1023px) {
      margin-left: -1rem;
    }
  }
  .mobile-horizontal-scroll::-webkit-scrollbar {
    // hide unless scrolling on safari and chrome
    @media (max-width: 767px) {
      display: none;
    }
  }
</style>

<ul
  class="fizz-tab-list mobile-horizontal-scroll fizz-stack-16 fizz-expand-32-on-large fizz-expand-16-on-small"
  data-testid="list-tabs"
>
  <li
    class:fizz-is-active={activeDynamicFiltersTab === "approved_products"}
    on:click={() => {
      activeDynamicFiltersTab = "approved_products";
    }}
  >
    All approved products
  </li>
  <li
    class:fizz-is-active={activeDynamicFiltersTab === "product_groups"}
    on:click={() => clickOpenProductGroupTab()}
    data-testid="open-product-groups-tab"
  >
    Open product groups
  </li>
</ul>
{#if activeDynamicFiltersTab === "approved_products"}
  <ProductList
    {showInventory}
    fullCount={list.full_count}
    {list}
    {page}
    {filters}
    {products}
    {editMode}
    {sortObj}
    on:selectFilter
    {readOnly}
    {callbacks}
    {useListLayout}
    {showLoading}
    {listType}
  />
{:else if activeDynamicFiltersTab === "product_groups"}
  <OpenProductGroupSummary {openProductGroups} />
{/if}
